const TYPE_ORGANISATION = 'Organisation';
const TYPE_PERSON = 'Person';
const TYPE_EMAIL_CONTACT = 'EmailContact';
const TYPE_CUSTOMER = 'Customer';

export default class CustomerAccountInfo {
  constructor(data) {
    this._data = data;
  }

  /**
   * @return {?string}
   */
  get legalType() {
    return this._data.legalType;
  }

  /**
   * Returns `name` for corporate entities and `fullName` for private customers
   *
   * @return {?string}
   */
  get name() {
    if (this._data['@type'] === TYPE_PERSON) {
      return this._data.fullName;
    }
    if (this._data['@type'] === TYPE_ORGANISATION) {
      return this._data.name;
    }
    return null;
  }

  /**
   * @return {?string}
   */
  get email() {
    return this._emailContact?.emailAddress;
  }

  /**
   * @return {?object}
   * @private
   */
  get _emailContact() {
    return this._customerParty?.contactableVia.find(
      contact => contact['@type'] === TYPE_EMAIL_CONTACT,
    );
  }

  /**
   * @return {?object}
   * @private
   */
  get _customerParty() {
    return this._data?.partyRole.find(party => party['@type'] === TYPE_CUSTOMER);
  }

  /**
   * @param {string} email
   * @return {[{op: string, path: string, value: string}]}
   */
  static createEmailPatchBody(email) {
    return [
      {
        op: 'replace',
        path: `partyRole/contactableVia[@type='${TYPE_EMAIL_CONTACT}']/emailAddress`,
        value: email,
      },
    ];
  }
}
